



















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

const { AgGridVue } = require('ag-grid-vue');

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { fetchAtenciones } from './fetchAtenciones';

import AtencionesTab from './tabs/AtencionesTab.vue';
import SeriesTab from './tabs/SeriesTab.vue';
import ProductsTab from './tabs/ProductsTab.vue';
import { DataApi } from './models/AtencionesBase.model';
import { DataApi as Api } from './models/AtencionesModalVerDetalle.model';

@Component({
  components: {
    AtencionesTab,
    ProductsTab,
    SeriesTab,
    GridComponent: AgGridVue,
  },
})
export default class AtencionesModalVerDetalle extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  gridOptions: GridOptions = null;
  gridApi: GridApi = null;
  gridEvent: any = null;
  columnApi: any = null;

  step: string = 'attentions';
  dialog: boolean = true;
  currentId: Record<string, string> = {
    products: null,
    series: null,
  };

  dataApi: Api = {
    products: [],
    series: [],
  };
  localData: DataApi = {};
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  constructor() {
    super();
    this.localData = this.data;
    this.gridOptions = {
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData([{}]);
  }

  handleClosed(): void {
    this.localData = {};
    Object.keys(this.currentId).forEach(key => (this.currentId[key] = null));
    this.$emit('cerrar');
  }

  @Watch('step')
  async validateValue() {
    if (
      this.step === 'products' &&
      this.currentId.products !== this.localData.ndvnumero
    ) {
      this.dataApi.products = await this.getTab({});
      this.currentId.products = this.localData.ndvnumero;
    } else if (
      this.step === 'series' &&
      this.currentId.series !== this.localData.ndvnumero
    ) {
      this.dataApi.series = await this.getTab({ tag: 'series' });
      this.currentId.series = this.localData.ndvnumero;
    }
  }

  async getTab({ tag = 'products' }): Promise<any> {
    const self = this;
    self.loadingService.showLoading();
    return await fetchAtenciones({
      endpoint: 'get_tab',
      body: {
        tag,
        ndvnumero: this.localData.ndvnumero,
        atenumero: this.localData.atenumero,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA) {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        return LISTA;
      })
      .catch((error: Error) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => self.loadingService.hideLoading());
  }
}
